import { merge } from '../../../helper';

import * as exList from '../utils';

// ----------------------------------------------------------------------------

function data(element: HTMLElement, config: Record<string, any> = {}): any[] {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list = exList.data(element, {
        merge: defConfig,
        class: {
            new: 'list-group-item',
        },
    });

    // ------------------------------------------------------------------------

    // Return
    return list;
}

// ----------------------------------------------------------------------------

export { data };
